import { usingGet } from '@ocean/api'

export const getSurveyDetails = (surveyId: Guid, resultId?: Guid) => {
  const baseUrl = `surveys/details/${surveyId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}
